/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc PC端设置支付密码
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  payPasswordDTO: member.PayPasswordDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/pc/setting/pay-password`,
    data: payPasswordDTO,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
